/* eslint-disable max-len */
import React from 'react';

import {
  Typography,
} from '@material-ui/core';
import BacePolicy from '../../components/base_policy';

const IndexPage = () => (
  <BacePolicy>
    <ul>
      <li><Typography paragraph variant="body2">ユーザー作成データ<br />記録データを端末のストレージに保存します。</Typography></li>
      <li><Typography paragraph variant="body2">連絡先情報<br />Google Driveへのバックアップ機能の利用時にアカウント作成のため、メールアドレスを取得し、アカウントIDの作成を行います</Typography></li>
      <li><Typography paragraph variant="body2">送信情報<br />本アプリはGoogle Drive または iCloudへのバックアップ機能を提供しています。バックアップを利用した場合は「ユーザー作成データ・画像データ」がGoogle Drive または iCloudへ送信されます。</Typography></li>
    </ul>
  </BacePolicy>
);

export default IndexPage;
